import { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export const useProfileCompletion = () => {
  const { user } = useAuth();
  const [isProfileComplete, setIsProfileComplete] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkProfileCompletion = async () => {
      if (!user) {
        setIsProfileComplete(null);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('first_name, last_name, phone, street_address, city, province, postal_code, country')
          .eq('id', user.id)
          .single();

        if (error) {
          console.error('Error checking profile:', error);
          setIsProfileComplete(false);
          setLoading(false);
          return;
        }

        // Vérifier si tous les champs obligatoires sont remplis
        const isComplete = !!(
          data?.first_name &&
          data?.last_name &&
          data?.phone &&
          data?.street_address &&
          data?.city &&
          data?.province &&
          data?.postal_code &&
          data?.country
        );

        setIsProfileComplete(isComplete);
      } catch (error) {
        console.error('Error checking profile completion:', error);
        setIsProfileComplete(false);
      } finally {
        setLoading(false);
      }
    };

    checkProfileCompletion();
  }, [user]);

  return { isProfileComplete, loading };
};
